import React, { useState, useEffect} from 'react';
import AnalyticsList from './AnalyticsList';
import { Card, CardContent, Grid, Button, makeStyles} from '@material-ui/core';
import axios from 'axios';
import settings from '../../settings';

const useStyles = makeStyles((theme) => ({
    button: {
      fontSize: "1em",
      borderRadius: "5px",
      margin: "10px 0px",
      cursor: "pointer",
    },
  }));  

const AnalyticsViews = ({className}: {className?: string}) => {
    const classes = useStyles();
    const [day, setDay] = useState<any[]>([]);
    const [week, setWeek] = useState<any[]>([]);
    
    useEffect(() => {
        axios.get(settings.analyticsApi + "/best/article/day", {params: {limit: 20}}).then(r => {
            setDay(r.data.best);
        });
        axios.get(settings.analyticsApi + "/best/article/week", {params: {limit: 20}}).then(r => {
            setWeek(r.data.best);
        })
    }, []);

    return <>
        <Card className={className}>
            <CardContent>
                <h2>Les articles les plus vus </h2>
                <Button
                    className={classes.button}
                    variant="contained"
                    color="primary"
                    href="https://analytics.google.com/analytics/web/#/"
                    target="_blank"
                    rel="noopener noreferrer">
                    Voir le détail sur Google Analitycs
                </Button>
                <Grid direction="row" container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <AnalyticsList
                        name="Aujourd'hui"
                        data={day}/>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <AnalyticsList
                        name="Cette semaine"
                        data={week}/>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    </>
}

export default AnalyticsViews;